module.exports = __webpack_public_path__ + "img/金豐30.625ea5e7.svg";